import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { logout } from '../Controllers/AuthController';

/**
 * Full-screen lockout shown to every user when REACT_APP_MAINTENANCE_MODE is
 * truthy, except the configured bypass email (see Routes.jsx). Used during
 * data migrations and incident windows to keep operators out of the booking
 * editor while writes are unsafe.
 *
 * The signed-in user can log out — useful if they want to switch to the
 * bypass account without clearing local storage manually.
 */
function MaintenanceScreen({ email }) {
  const handleLogout = async () => {
    await logout();
    // Hard reload so AuthController re-runs against a fresh session.
    window.location.href = '/login';
  };

  return (
    <Container
      fluid
      className="d-flex flex-column align-items-center justify-content-center text-center"
      style={{ minHeight: '100vh', padding: '2rem' }}
    >
      <div style={{ maxWidth: 520 }}>
        <i className="fa fa-wrench fa-4x text-primary opacity-50 mb-4 d-block" />
        <h1 className="h3 mb-3">Under maintenance</h1>
        <p className="text-muted mb-4">
          The dashboard is temporarily unavailable while we finish a data migration.
          You&apos;ll be able to sign back in once it&apos;s complete.
        </p>
        {email && (
          <p className="small text-muted mb-3">
            Signed in as
            {' '}
            <strong>{email}</strong>
          </p>
        )}
        <Button variant="outline-secondary" size="sm" onClick={handleLogout}>
          <i className="fa fa-sign-out-alt me-2" />
          Sign out
        </Button>
      </div>
    </Container>
  );
}

export default MaintenanceScreen;
